module.exports = __webpack_public_path__ + "img/logo-v2-min.9047048b.svg";